import React, { JSX } from "react";
import { Container, TextFieldStyled } from "./TextInput.styled";

export type TextInputProps = {
  containerProps?: React.ComponentProps<typeof Container>,
} & React.ComponentProps<typeof TextFieldStyled>;

export const TextInput: React.FC<TextInputProps> = (props): JSX.Element => {
  const { containerProps, ...rest } = props;
  return (
    <Container {...containerProps}>
      <TextFieldStyled {...rest} />
    </Container>
  );
};
